<template>
  <div>
    <demo-block >
      <van-button @click="show1 = true">aaaaaaaaaaaaa</van-button>
      <van-popup v-model="show1">ddddddddd</van-popup>
    </demo-block>

    <demo-block >
      <van-button @click="show2 = true;">fffffffffffff</van-button>

     

      <van-button @click="show3 = true">bbbbbbbbbbbbb</van-button>
      <van-popup v-model="show3" position="top" :overlay="false">
       vvvvvvvvvvv
      </van-popup>

      <van-button @click="show4 = true">aaaaaaaaa2aaa</van-button>
      <van-popup v-model="show4" position="top">
        <van-button @click="show4 = false">ddddddd1dddd</van-button>
        <van-button @click="show5 = true">fffffffff</van-button>
        <van-popup v-model="show5" position="top">
          <van-button @click="show5 = false">aaaaaaaa3saaaaaa</van-button>
        </van-popup>
      </van-popup>
    </demo-block>
  </div>
</template>

<script>
  import { Tabbar, TabbarItem, CellGroup } from 'vant';
  import { NavBar, Tab, Tabs, Search, Button, Field, Popup, Tag } from 'vant';
  import qs from 'qs'; 
  import { List, Cell } from 'vant';
  import { Row, Col } from 'vant';
  import { Loading } from 'vant';
  import request from '@/utils/request' 
  import { Toast,Dialog,Icon} from 'vant'
  import moment from 'moment'
  
export default {
  i18n: {
    'zh-CN': {
      position: '弹出位置',
      button1: '弹出 Popup',
      button2: '底部弹出',
      button3: '弹出 Dialog',
      button4: '顶部弹出',
      button5: '右侧弹出',
      button6: '关闭弹层',
      columns: ['杭州', '宁波', '温州', '嘉兴', '湖州']
    },
    'en-US': {
      position: 'Position',
      button1: 'Show Popup',
      button2: 'From Bottom',
      button3: 'Show Dialog',
      button4: 'From Top',
      button5: 'From Right',
      button6: 'Close Popup',
      columns: ['Delaware', 'Florida', 'Georqia', 'Indiana', 'Maine']
    }
  },

    components: {   
      'van-search': Search, 
    'van-icon':Icon,
      'van-field': Field, 
      'van-button': Button,
      'van-list': List,
      'van-cell': Cell,
      'van-tag': Tag,
      'van-col': Col,
      'van-row': Row,
     
      'van-popup': Popup,
      
      'van-loading':Loading
    },
  data() {
    return {
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false
    };
  },

  watch: {
    show3(val) {
      if (val) {
        setTimeout(() => {
          this.show3 = false;
        }, 2000);
      }
    }
  },

  methods: {
    showDialog() {
    }
  }
};
</script>

<style lang="postcss">
.demo-popup {
  .van-button {
    margin: 10px 0 10px 15px;
  }

  .van-popup {
    width: 60%;
    padding: 20px;
    box-sizing: border-box;

    &--bottom {
      width: 100%;
      padding: 0;
      border-radius: 0;
    }

    .van-tabs__content {
      height: 156px;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
    }

    .van-tab__pane:not(:first-child) {
      padding: 10px;
      line-height: 1.4;
      color: #666;
    }

    &--top {
      color: #fff;
      width: 100%;
      border-radius: 0;
      line-height: 20px;
      background-color: rgba(0, 0, 0, 0.8);
    }

    &--left,
    &--right {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/test.vue